export const convertStringToLanguageKey = (string) => string?.toLowerCase().replace(/ /g, "-") || "-";
